import angular from 'angular';
import _debounce from 'lodash/debounce';
import viewStudentsTemplate from './../view-students/view-students.html';
import showSubstitutionTemplate from './../../informations/working-days/show-substitution/show-substitution.html';
import template from './realizations-by-teacher.html';
var RealizationsByTeacherComponent = /** @class */ (function () {
    function RealizationsByTeacherComponent($log, $mdDialog, $mdToast, moment, RealizationService, SubstitutionService) {
        this.$log = $log;
        this.$mdDialog = $mdDialog;
        this.$mdToast = $mdToast;
        this.moment = moment;
        this.RealizationService = RealizationService;
        this.SubstitutionService = SubstitutionService;
        this.realizations = [];
        this.dateTo = this.moment().toDate();
        this.dateFrom = this.moment().subtract(7, 'days').toDate();
    }
    RealizationsByTeacherComponent.prototype.$onInit = function () {
        if (this.teachers) {
            this.teacher = this.teachers[0];
        }
    };
    RealizationsByTeacherComponent.prototype.$onChanges = function (changes) {
        if (changes.teachers) {
            this.teachers = Object.assign([], this.teachers);
        }
    };
    RealizationsByTeacherComponent.prototype.getLoadResultsCallback = function (loadPageCallback) {
        this.loadPageCallbackWithDebounce = _debounce(loadPageCallback, 1000);
    };
    RealizationsByTeacherComponent.prototype.paginatorCallback = function (page, pageSize) {
        var _this = this;
        var offset = (page - 1) * pageSize;
        if (angular.isUndefined(offset)) {
            offset = 0;
        }
        return this.RealizationService.getByEmployee({
            dateFrom: this.moment(this.dateFrom).format('YYYY-MM-DD'),
            dateTo: this.moment(this.dateTo).format('YYYY-MM-DD'),
            offset: offset,
            limit: pageSize
        }, this.teacher.id).then(function (result) {
            _this.realizations = result.data.realizations.map(function (realization) {
                realization.description = {
                    value: realization.description,
                    substitution: Boolean(realization.substituteActivity),
                    substituteActivity: realization.substituteActivity
                };
                return realization;
            });
            return {
                results: result.data.realizations,
                totalResultCount: result.data.total
            };
        });
    };
    RealizationsByTeacherComponent.prototype.setFilter = function (form) {
        if (form.$invalid) {
            return false;
        }
        this.loadPageCallbackWithDebounce();
    };
    RealizationsByTeacherComponent.prototype.openAttendances = function (students, ev) {
        if (students.length > 0) {
            this.$mdDialog.show({
                bindToController: true,
                controllerAs: 'ctrl',
                controller: 'ViewStudentsController',
                template: viewStudentsTemplate,
                locals: { students: students },
                clickOutsideToClose: true,
                targetEvent: ev
            });
        }
        else {
            this.$mdToast.show(this.$mdToast.simple()
                .textContent('Brak uczniów na zajęciach')
                .position('bottom right')
                .hideDelay(3000));
        }
    };
    RealizationsByTeacherComponent.prototype.openSubstitution = function (substituteActivityId, ev) {
        var _this = this;
        if (angular.isDefined(substituteActivityId)) {
            this.SubstitutionService.getActivity(substituteActivityId)
                .then(function (substituteActivitie) {
                _this.$mdDialog.show({
                    bindToController: true,
                    controllerAs: 'ctrl',
                    controller: 'ShowSubstitutionController',
                    template: showSubstitutionTemplate,
                    locals: {
                        substituteActivitie: substituteActivitie
                    },
                    clickOutsideToClose: true,
                    targetEvent: ev
                });
            })
                .catch(function (error) {
                _this.$mdDialog.show(_this.$mdDialog.extendError({
                    locals: { error: error }
                }));
            });
        }
    };
    RealizationsByTeacherComponent.prototype.remove = function (id, ev) {
        var _this = this;
        ev.stopPropagation();
        this.RealizationService.delete({ id: id }).then(function () {
            _this.$mdToast.show(_this.$mdToast.simple()
                .textContent('Usunięto realizację')
                .position('bottom right')
                .hideDelay(3000));
        })
            .catch(function () {
            _this.$mdToast.show(_this.$mdToast.simple()
                .textContent('Nie udało się usunąć rozmowy')
                .position('bottom right')
                .hideDelay(3000));
        });
    };
    RealizationsByTeacherComponent.$inject = ['$log', '$mdDialog', '$mdToast', 'moment', 'RealizationService', 'SubstitutionService'];
    return RealizationsByTeacherComponent;
}());
export var RealizationsByTeacher = {
    bindings: {
        teachers: '<'
    },
    template: template,
    controller: RealizationsByTeacherComponent
};
